const { YearEndFinancialDate } = require('year-end-financial-date');

const deps = [require('ngreact').name];

module.exports = angular
  .module('bench.ui.bk.yearEndFinancialDate', deps)
  .directive('yearEndFinancialDate', reactDirective => reactDirective(YearEndFinancialDate));
